import { render, staticRenderFns } from "./ModalUnavailableProducts.vue?vue&type=template&id=67420d31&"
import script from "./ModalUnavailableProducts.vue?vue&type=script&lang=js&"
export * from "./ModalUnavailableProducts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports